module.exports = __webpack_public_path__ + "static/media/poll.3c6c3134.svg";